import apiClient from '@/services/axios'

export const post = async (mediaspaceAd) => {
    const response = await apiClient.post('/mediaspace', mediaspaceAd)
    return response.data
} 